// Estado UI de la Traducción automática (por conversación y por cliente):
// mientras la pestaña "Traducción" está seleccionada, los mensajes entrantes
// se muestran traducidos al idioma del agente (incomingLang) y lo que escribe
// el agente se envía traducido al idioma destino (targetLang).
const state = {
  byConversation: {},
};

export const getters = {
  getIsActive: $state => conversationId =>
    Boolean($state.byConversation[conversationId]?.active),
  getTargetLang: $state => conversationId =>
    $state.byConversation[conversationId]?.targetLang || 'en',
  getIncomingLang: $state => conversationId =>
    $state.byConversation[conversationId]?.incomingLang || 'es',
};

export const actions = {
  setActive({ commit }, { conversationId, active, incomingLang }) {
    commit('SET_AUTO_TRANSLATION_STATE', {
      conversationId,
      patch: { active, incomingLang },
    });
  },
  setTargetLang({ commit }, { conversationId, targetLang }) {
    commit('SET_AUTO_TRANSLATION_STATE', {
      conversationId,
      patch: { targetLang },
    });
  },
};

export const mutations = {
  SET_AUTO_TRANSLATION_STATE($state, { conversationId, patch }) {
    $state.byConversation[conversationId] = {
      ...($state.byConversation[conversationId] || {}),
      ...patch,
    };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
